import { FileStack, UserCircle2 } from "lucide-react";

export default function Header({ onProfileClick }) {
  return (
    <header className="bg-white border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3" data-testid="app-header-logo">
          <div className="w-11 h-11 rounded-2xl bg-blue-700 flex items-center justify-center shadow-sm">
            <FileStack className="w-6 h-6 text-white" />
          </div>
          <div>
            <h1 className="text-lg font-extrabold text-slate-900 leading-tight">Papirko</h1>
            <p className="text-xs text-slate-500">Pametni pomoćnik za školsku administraciju</p>
          </div>
        </div>
        <button
          data-testid="my-profile-button"
          onClick={onProfileClick}
          className="flex items-center gap-2 bg-slate-100 hover:bg-slate-200 text-slate-800 font-semibold px-4 py-2 rounded-xl border border-slate-200 transition-all text-sm"
        >
          <UserCircle2 className="w-4 h-4 text-blue-700" />
          Moj profil
        </button>
      </div>
    </header>
  );
}
